import Swal from "sweetalert2";

export const notify = {
  success: (title, message = "") => {
    Swal.fire({
      title: title,
      text: message,
      icon: "success",
      iconColor: "hsl(49, 87%, 48%)",
      width: "280px", 
      showConfirmButton: true, // Force the button to render explicitly
      confirmButtonText: "OK",   // Provide explicit text for the button
      buttonsStyling: false,
      showClass: { popup: "animate-swal-in" },
      hideClass: { popup: "animate-swal-out" },
      customClass: {
        popup:
          "rounded-[1.8rem] bg-brand-body dark:bg-brand-dark border-none shadow-2xl p-5 flex flex-col items-center", // Ensure center flex alignment
        icon: "swal2-icon-small mx-auto", // Center the icon
        title: "text-sm font-black text-brand-dark dark:text-white pt-2 text-center",
        htmlContainer: "text-[11px] text-slate-500 mt-1 text-center",
        actions: "w-full flex justify-center mt-4", // Added action container targeting
        confirmButton:
          "bg-brand-gradient bg-amber-500 text-white px-6 py-2 rounded-full font-bold text-[10px] uppercase tracking-wider hover:scale-105 transition-transform active:scale-95 block shadow-lg shadow-orange-500/20",
      },
    });
  },
  
  error: (title, message = "") => {
    Swal.fire({
      title: title,
      text: message,
      icon: "error",
      iconColor: "#D4AF37",
      width: "280px",
      showConfirmButton: true, // Force button visible
      confirmButtonText: "OK",
      buttonsStyling: false,
      showClass: { popup: "animate-swal-shake" },
      hideClass: { popup: "animate-swal-out" },
      customClass: {
        popup:
          "rounded-[1.8rem] bg-brand-body dark:bg-brand-dark border border-red-50 shadow-2xl p-5 flex flex-col items-center",
        icon: "swal2-icon-small mx-auto",
        title: "text-sm font-black text-red-600 pt-2 text-center",
        htmlContainer: "text-[11px] text-slate-500 mt-1 text-center",
        actions: "w-full flex justify-center mt-4",
        confirmButton:
          "bg-red-500 text-white px-6 py-2 rounded-full font-bold text-[10px] uppercase tracking-wider hover:bg-red-600 block",
      },
    });
  },

  toast: (title, icon = "success") => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      customClass: {
        popup:
          "animate-fade-up rounded-xl shadow-xl border border-orange-50 bg-white dark:bg-brand-dark px-3 py-2",
        icon: "swal2-icon-toast-small",
        title:
          "text-[10px] font-black dark:text-white text-slate-700 uppercase tracking-tight ml-[-5px]",
      },
    });
    Toast.fire({ icon, title });
  },
};